import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b380d84&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b380d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b380d84')) {
      api.createRecord('0b380d84', component.options)
    } else {
      api.reload('0b380d84', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b380d84&scoped=true", function () {
      api.rerender('0b380d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/ActiveDisposal/index.vue"
export default component.exports